<template>
  <component
    v-for="question in questions"
    :key="question.id"
    :is="getComponent(question)"
    :question="question" />
</template>

<script setup lang="ts">
import QuestionInputNumber from './QuestionInputNumber.vue';
import QuestionInputDate from './QuestionInputDate.vue';
import QuestionInputSelectSingle from './QuestionInputSelectSingle.vue';
import QuestionInputSelectMulti from './QuestionInputSelectMulti.vue';
import QuestionInputToggle from './QuestionInputToggle.vue';
import QuestionInputText from './QuestionInputText.vue';
import type { QstQuestionDetails } from '@/types/Questionnaires';

defineProps<{
  questions: QstQuestionDetails[];
}>();

const componentMap: any = {
  INT: QuestionInputNumber,
  INTN: QuestionInputNumber,
  INTN0: QuestionInputNumber,
  FLOAT: QuestionInputNumber,
  FLOATN: QuestionInputNumber,
  FLOATN0: QuestionInputNumber,
  DATE: QuestionInputDate,
  DATETIME: QuestionInputDate,
  TIME: QuestionInputDate,
  LIST_SINGLE: QuestionInputSelectSingle,
  LIST_MULTISELECT: QuestionInputSelectMulti,
  BOOLEAN: QuestionInputToggle,
  STRING: QuestionInputText,
};

function getComponent(question: QstQuestionDetails) {
  if (question.mwDataType.name) return componentMap[question.mwDataType.name];
}
</script>
